import React, { useState, useCallback, memo, useMemo, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { ALL_USERS } from '../../../graphql/queries';
import Notification from '../../../components/Notification/Notification';
import MateList from './MateList/MateList';
import SignupLinks from './SignupLinks/SignupLinks';
import PushBroadcastCard from './PushBroadcastCard/PushBroadcastCard';
import './MateManagement.css';

const MateManagement = memo(({ initialTab = 'users' }) => {
  const navigate = useNavigate();
  const [notification, setNotification] = useState({ open: false, message: '', type: 'info' });
  const [activeTab, setActiveTab] = useState(initialTab); // 'users' | 'signup-links' | 'send-notifications'

  useEffect(() => {
    setActiveTab(initialTab);
  }, [initialTab]);

  // Helper function to show notifications
  const showNotification = useCallback((message, type = 'info') => {
    setNotification({ open: true, message, type });
  }, []);

  const handleCloseNotification = useCallback(() => {
    setNotification(prev => ({ ...prev, open: false }));
  }, []);

  // GraphQL query for all users
  const { data: usersData, loading: matesLoading, refetch: refetchUsers } = useQuery(ALL_USERS, {
    onError: (error) => {
      showNotification('Fejl ved hentning af brugere: ' + error.message, 'error');
    }
  });

  // Get mates from GraphQL data
  const mates = useMemo(() => usersData?.allUsers || [], [usersData?.allUsers]);

  return (
    <div className="mate-management-admin">
      <Notification
        open={notification.open}
        onClose={handleCloseNotification}
        message={notification.message}
        type={notification.type}
      />

      {activeTab === 'signup-links' && (
        <div className="signup-links-section">
          <SignupLinks mates={mates} />
        </div>
      )}

      {activeTab === 'send-notifications' && (
        <div className="send-notifications-section">
          <PushBroadcastCard />
        </div>
      )}

      {activeTab === 'users' && (
        // TODO: der skal være en rute til mate listen
        <MateList
          mates={mates}
          loading={matesLoading}
          onRowClick={(mate) => navigate(`/admin/mate/${mate.id}`)}
        />
      )}
    </div>
  );
});

MateManagement.displayName = 'MateManagement';

export default MateManagement;
